<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[600px] mx-auto bg-white border rounded-lg"
  >
    <div class="pb-6 rounded-lg">
      <div class="p4-4 text-xl text-center bg-red-600">{{ prettyName(title) }}</div>
      <div class = "p-6">
        {{ buildMessage }}
        <div class=" max-h-72 overflow-auto">
          <table class="m-6">
            <thead class=" bg-gray-300">
              <tr>
                <th v-for="fld in fields" class="bold" :key="fld">{{ titleize(fld) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="pt-4 pl-4" v-for="(item, index) in previous_items" :key="index">
                <td v-for="(fld, idx) in fields" :class="valueClass[idx]" :key="fld">{{ item[fld] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <button class="pad btn btn-primary float-right" @click="closeModal()">Ok</button>

      <div class="h-10">&nbsp;</div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { VueFinalModal } from 'vue-final-modal'
  import { onMounted, ref, reactive, computed } from 'vue'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let title = ref(props.params.title)
  let previous_items = reactive(props.params.previous_items)
  let fields = reactive([])
  let type = ref(props.params.type || 'church')
  let message = ref('')

  onMounted(() => {
    fields = previous_items && Object.keys(previous_items[0])
  })

  const buildMessage = computed(() => {
    switch (type.value) {
      case 'church-visit':
        message.value = `This Church has already been visited in the past by you or another field rep. Please ensure that you are not creating a duplicate Church visit before proceeding!`
        break;
      case 'church-1g':
        message.value = 'This Church Planter already has other Churches, please ensure you are not creating a duplicate Church before proceeding'
        break;
      case 'church-2g':
        message.value = 'This Church Planter already has other 2G+ Churches, please ensure you are not creating a duplicate Church before proceeding'
        break;
      case 'training-center-visit':
        message.value = 'This Training Center has already been visited twice in the past by you or another field rep. Please ensure that you are not creating a duplicate visit before proceeding!'
        break;
      default:
        break;

    }

    return message.value
  })

  const headingClass = computed(() => {
    return fields.map((fld, idx) => { return  idx == 0 ? 'max-w-min font-bold' : 'font-bold' })
  }) 

  const valueClass = computed(() => {
    return fields.map((fld, idx) => { 
      console.log(fld)
      console.log(idx)
      let val = idx == 0 ? 'max-w-min' : ''
      console.log(val)
      return val
    })
  })

  function closeModal () {
    emit("close")
  }

  function prettyName (str) {
    if (str) {
      var rString = str.replace(/_/g,' ')
      return rString.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase())
    }
  }
</script>

<style>
  .info {
    padding: 10px;
  }
  .bold {
    font-weight: bold;
  }
  .value {
    padding-left: 5px;
  }
</style>
